import { CustomState } from "@iewc/Store/Reducers";
import addMaximumScaleToViewport from "@insite/client-framework/Common/Utilities/addMaximumScaleToViewport";
import Zone from "@insite/client-framework/Components/Zone";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import isMobile from "ismobilejs";
import * as React from "react";
import { useEffect } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: CustomState) => {
    const enableAccountCreation = (getSettingsCollection(state) as any).customAccountSettings.enableAccountCreation;
    return {
        currentPageType: getCurrentPage(state).type,
        enableAccountCreation,
    };
};

type Props = PageProps & ReturnType<typeof mapStateToProps>;

export const CreateAccountPage = ({ id, currentPageType, enableAccountCreation }: Props) => {
    useEffect(() => {
        if (isMobile(window.navigator).apple.tablet || isMobile(window.navigator).apple.phone) {
            addMaximumScaleToViewport();
        }

        if (currentPageType !== "NullPage" && currentPageType === "CreateAccountPage" && !enableAccountCreation) {
            window.location.replace("/");
        }
    }, []);

    return (
        <Page>
            <Zone zoneName="Content" contentId={id} />
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps)(CreateAccountPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;
/**
 * @deprecated Use string literal "CreateAccountPage" instead of this constant.
 */
export const CreateAccountPageContext = "CreateAccountPage";
